import React from 'react'

const SaveButton = ({ fill = '#121212' }) => (
  <svg width="22px" height="22px" viewBox="0 0 14 21.3">
    <g id="bookmark">
      <path className="st0" fill="none" d="M14,21.3l-7-4.8l-7,4.8V0h14V21.3z" />
      <path
        className="st1"
        fill={fill}
        d="M13,19.4V1H1v18.4l5.4-3.7L7,15.3l0.6,0.4L13,19.4 M14,21.3l-7-4.8l-7,4.8V0h14V21.3z"
      />
    </g>
  </svg>
)

export default SaveButton
